<template>
  <div class="bg-custom">
    <v-row>
      <v-col cols="6" class="px-0 pt-0">
        <v-sheet color="white" class="pa-2">
          <div class="px-6 pb-5">
            <v-card-actions class="pa-0">
              <h2>
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.examReport'
                  )
                }}
              </h2>
            </v-card-actions>
          </div>
        </v-sheet>
      </v-col>
      <v-col lg="6" class="px-0 pt-0">
        <v-sheet color="white" class="pa-2">
          <div class="px-6 pb-5">
            <v-card-actions class="pa-0 justify-content-right">
              <v-btn
                elevation="0"
                :loading="onExportAllExamLoading"
                @click="openSelectAllExportDialog"
                class="font-weight-light body-2 button-secondary exportAllExam"
              >
                <v-icon left class="icon-color-inherit"
                  >mdi-microsoft-excel</v-icon
                >{{
                  $vuetify.lang.t('$vuetify.courseManagement.courseReport.exportAll')
                }}
              </v-btn>
              <v-btn
                @click="goToCourseDetail"
                elevation="0"
                class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
                >
                {{
                    $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.courseDetail'
                    )
                }}
                </v-btn>
            </v-card-actions>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-form ref="form" class="pa-5">
      <v-row>
        <v-col cols="12" class="px-3">
          <v-sheet color="white" class="pa-2">
            <v-row class="px-3">
              <v-col cols="12" sm="6" md="6">
                <span class="caption">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.exam'
                    )
                  }}
                </span>
                <!-- <p class="subtitle-1 my-auto font-weight-medium align-center">
            {{
              $vuetify.lang.t('$vuetify.courseManagement.courseReport.exam')
            }}:
          </p> -->
                <v-autocomplete
                  v-model="examSelect"
                  :items="exam_item"
                  item-text="title"
                  item-value="_id"
                  outlined
                  placeholder="กรุณาเลือกชุดข้อสอบ"
                  background-color="white"
                  hide-details
                  @change="filterReport"
                  height="40"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="mt-auto">
                <p class="caption mb-0">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.statusFace'
                    )
                  }}
                </p>
                <p
                  v-if="checkFaceDetection == false"
                  class="subtitle-1 mb-0 grey--text"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.nofaceDetection'
                    )
                  }}
                </p>
                <v-btn-toggle
                  v-if="checkFaceDetection == true"
                  class="mb-0"
                  color="primary accent-3"
                  background-color="white"
                  mandatory
                  v-model="status_toggle"
                  @change="applyFilterReportExam"
                >
                  <v-btn class="text-capitalize body-2" height="40px">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.all'
                      )
                    }}
                  </v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.pass'
                      )
                    }}
                  </v-btn>
                  <v-btn class="text-capitalize body-2" height="40px">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.fail'
                      )
                    }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="3"
                class="mt-auto"
                style="display: flex; justify-content: flex-end"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="pl-5 pr-5 btn-reload body-2"
                      height="40"
                      @click="initialize"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    $vuetify.lang.t(
                      '$vuetify.learnerManagement.filterBar.reload'
                    )
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="px-4 pb-2">
              <v-col cols="6">
                <span class="caption">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.filterBar.groupFilter'
                    )
                  }}
                </span>
                <v-select
                  v-model="userGroupSearch"
                  :items="arrayGroup"
                  @change="applyFilterReportExam"
                  item-text="title"
                  item-value="_id"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.filterBar.selectGroup'
                    )
                  "
                  multiple
                  small-chips
                  outlined
                  dense
                  hide-details
                  required
                  background-color="white"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggle">
                      <v-list-item-action>
                        <v-icon
                          :color="userGroupSearch.length > 0 ? 'primary' : ''"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseReport.selectAll'
                            )
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <v-chip
                      class="ma-1"
                      v-if="item === Object(item)"
                      v-bind="attrs"
                      :input-value="selected"
                      label
                      small
                    >
                      <span class="pr-2">
                        {{ item.title }}
                      </span>
                      <v-icon small @click="parent.selectItem(item)">
                        mdi-close-circle
                      </v-icon>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="6">
                <span class="caption">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.filterExam'
                    )
                  }}
                </span>
                <p
                  v-if="!examReportDetail[0].countterm"
                  class="subtitle-1 mb-0 grey--text"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.notReadyNumber'
                    )
                  }}
                </p>
                <v-select
                  v-model="countTerm"
                  :items="examReportDetail[0].countterm"
                  @change="applyFilterReportExam"
                  item-text="term"
                  item-value="term"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.selectNumber'
                    )
                  "
                  multiple
                  small-chips
                  outlined
                  dense
                  hide-details
                  required
                  background-color="white"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleCount">
                      <v-list-item-action>
                        <v-icon :color="countTerm.length > 0 ? 'primary' : ''">
                          {{ iconCountTerm }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseReport.selectAll'
                            )
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <v-chip
                      class="ma-1"
                      v-if="item === Object(item)"
                      v-bind="attrs"
                      :input-value="selected"
                      label
                      small
                    >
                      <span class="pr-2">
                        {{ item.term }}
                      </span>
                      <v-icon small @click="parent.selectItem(item)">
                        mdi-close-circle
                      </v-icon>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="px-4 mb-1">
              <v-col cols="12">
                <p class="subtitle-1 mb-0 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.fullMarks'
                    )
                  }}:
                  <span v-if="!examReportDetail[0].maxScore" class="ml-4"
                    >-
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.marks'
                      )
                    }}</span
                  >
                  <span v-else class="ml-4"
                    >{{ examReportDetail[0].maxScore }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.marks'
                      )
                    }}</span
                  >
                </p>
                <p class="subtitle-1 mb-0 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.question'
                    )
                  }}:
                  <span v-if="!examReportDetail[0].countQuestion" class="ml-4"
                    >-
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.questions'
                      )
                    }}</span
                  >
                  <span v-else class="ml-4"
                    >{{ examReportDetail[0].countQuestion }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.questions'
                      )
                    }}</span
                  >
                </p>
                <p class="subtitle-1 mb-0 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.studentTest'
                    )
                  }}:
                  <span v-if="!examReportDetail[0].userTicket" class="ml-4"
                    >-
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                  <span v-else class="ml-4"
                    >{{ examReportDetail[0].userTicket }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                </p>
                <p class="subtitle-1 mb-0 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.faceDetectionPass'
                    )
                  }}:
                  <span v-if="!examReportDetail[0].faceSuccess" class="ml-4"
                    >-
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                  <span v-else class="ml-4"
                    >{{ examReportDetail[0].faceSuccess }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                </p>
                <p class="subtitle-1 mb-0 font-weight-medium">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.faceDetectionFail'
                    )
                  }}:
                  <span v-if="!examReportDetail[0].faceFail" class="ml-4"
                    >-
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                  <span v-else class="ml-4"
                    >{{ examReportDetail[0].faceFail }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.learner'
                      )
                    }}</span
                  >
                </p>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card-actions class="pa-0">
            <p class="subtitle-1 font-weight-bold">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.courseReport.detailLearner'
                )
              }}
            </p>

            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              @click="openSelectExportDialog"
              class="font-weight-light body-2 button-secondary"
            >
              <v-icon left class="icon-color-inherit"
                >mdi-microsoft-excel</v-icon
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.courseReport.export')
              }}
            </v-btn>
            <v-btn
                @click="openConfirmDeleteDialog"
                v-if="$store.state.permission.adminCompany"
                elevation="0"
                color="error"
                class="pl-5 pr-5 xs-full-width font-weight-light white--text"
                >
                {{
                    $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.clearTicketExam'
                    )
                }}
                </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items-per-page="params.limit"
            hide-default-footer
            :items="users"
            class="pa-mb-5 font-weight-light table-haveboder"
          >
            <template v-slot:item.numberExam="{ item }">
              <p class="mb-0">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.courseReport.test')
                }}
                {{ item.countTicket }}
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.testTime'
                  )
                }}
              </p>
            </template>
            <template v-slot:item.statusFace="{ item }">
              <p v-if="item.statusFace == 'nottest'" class="mb-0 grey--text">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.nottest'
                  )
                }}
              </p>
              <p v-if="item.statusFace == 'notface'" class="mb-0 grey--text">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.notface'
                  )
                }}
              </p>
              <p v-if="item.statusFace == 'fail'" class="mb-0 error--text">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.faceFail'
                  )
                }}
              </p>
              <p v-if="item.statusFace == 'success'" class="mb-0 success--text">
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.faceSuccess'
                  )
                }}
              </p>
              <!-- <p v-if="item.statusFace == 'error'" class="mb-0 warning--text">
                รอพิจารณา
              </p> -->
              <p v-if="item.statusFace == 'skip'" class="mb-0 warning--text">
                {{
                  $vuetify.lang.t('$vuetify.courseManagement.courseReport.skip')
                }}
              </p>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                v-on="on"
                color="white"
                elevation="0"
                class="font-weight-light text-primary text-capitalize"
                @click="openDialogReportTicket(item)"
              >
                {{
                  $vuetify.lang.t(
                    '$vuetify.courseManagement.courseReport.moreDetail'
                  )
                }}
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <div class="pt-3 pr-3 pb-5 text-center">
        <v-pagination
          v-model="params.page"
          :length="pageCount"
          @input="changePage"
          color="rgb(66, 154, 216)"
        ></v-pagination>
      </div>
    </v-form>
    <v-dialog v-model="dialogReportTicket" scrollable persistent width="1200px">
      <v-card>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-account-clock</v-icon
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.courseReport.history')
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="closeDialogUserTicket" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">{{
              $vuetify.lang.t('$vuetify.courseManagement.close')
            }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :loading="listTicketloading"
                :headers="headerStudentExam"
                hide-default-footer
                :items="userTicket"
                class="page-card font-weight-light custom-table"
                elevation="3"
              >
                <template v-slot:item.num="{ item }">
                  <p class="subtitle-2 font-weight-light">
                    {{ item.num }}
                  </p>
                </template>
                <template v-slot:item.examDate="{ item }">
                  <p class="subtitle-2 font-weight-light">
                    {{ item.examDate | moment('DD/MM/YYYY') }}
                  </p>
                </template>
                <template v-slot:item.start="{ item }">
                  <p class="subtitle-2 font-weight-light">
                    {{ item.start | moment('HH:mm') }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.unitTime'
                      )
                    }}
                  </p>
                </template>
                <template v-slot:item.end="{ item }">
                  <p v-if="item.end == 0" class="subtitle-2 font-weight-light">
                    -
                  </p>
                  <p v-if="item.end != 0" class="subtitle-2 font-weight-light">
                    {{ item.end | moment(' HH:mm') }}
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.unitTime'
                      )
                    }}
                  </p>
                </template>
                <template v-slot:item.timer="{ item }">
                  <p
                    v-if="item.timer != 0"
                    class="subtitle-2 font-weight-light"
                  >
                    {{ item.timer }}
                  </p>
                  <p
                    v-if="item.timer == 0"
                    class="subtitle-2 font-weight-light"
                  >
                    --:--:--
                  </p>
                </template>
                <template v-slot:item.score="{ item }">
                  <div class="backgroud-info">
                    <p
                      class="
                        ma-2
                        ml-0
                        md-fixed-width
                        subtitle-2
                        font-weight-light
                        info--text
                      "
                    >
                      {{ item.score }}
                    </p>
                  </div>
                </template>
                <template v-slot:item.correct="{ item }">
                  <div class="backgroud-success">
                    <p
                      class="
                        ma-2
                        ml-0
                        md-fixed-width
                        subtitle-2
                        font-weight-light
                        success--text
                      "
                    >
                      {{ item.correct }}
                    </p>
                  </div>
                </template>
                <template v-slot:item.wrong="{ item }">
                  <div class="backgroud-error">
                    <p
                      class="
                        ma-2
                        ml-0
                        md-fixed-width
                        subtitle-2
                        font-weight-light
                        error--text
                      "
                    >
                      {{ item.wrong }}
                    </p>
                  </div>
                </template>
                <template v-slot:item.noAnswer="{ item }">
                  <div class="backgroud-warning">
                    <p
                      class="
                        ma-2
                        ml-0
                        md-fixed-width
                        subtitle-2
                        font-weight-light
                        warning--text
                      "
                    >
                      {{ item.noAnswer }}
                    </p>
                  </div>
                </template>
                <template v-slot:item.faceDetect="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="item.statusFace == 'fail'"
                        v-on="on"
                        text
                        color="error"
                        class="font-weight-bold text-decoration-underline"
                        @click="openDialogFaceDetection(item)"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseReport.faceStatusNotPass'
                          )
                        }}
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.moreDetail'
                      )
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="item.statusFace == 'success'"
                        v-on="on"
                        text
                        color="success"
                        class="font-weight-bold text-decoration-underline"
                        @click="openDialogFaceDetection(item)"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseReport.faceStatusPass'
                          )
                        }}
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.moreDetail'
                      )
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="
                          item.statusFace == 'error' &&
                          item.photoFace.length > 0
                        "
                        v-on="on"
                        text
                        color="warning"
                        class="font-weight-bold text-decoration-underline"
                        @click="openDialogFaceDetection(item)"
                      >
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseReport.faceStatusError'
                          )
                        }}
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.moreDetail'
                      )
                    }}</span>
                  </v-tooltip>
                  <p
                    v-if="
                      item.statusFace == 'notface' && item.photoFace.length == 0
                    "
                    class="mb-0 grey--text"
                  >
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.courseReport.faceStatusNo'
                      )
                    }}
                  </p>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row align="center" justify="center">
                    <!-- <v-btn v-if="item.pending"
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            disabled
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  "$vuetify.courseManagement.courseList.pending"
                                )
                              }}
                            </p>
                          </v-btn> -->

                    <div
                      v-if="item.pending"
                      class="mb-0 body-2 text-capitalize"
                    >
                      <p class="mb-0 grey--text">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.courseList.pending'
                          )
                        }}
                      </p>
                    </div>

                    <v-menu offset-y v-if="!item.pending">
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon color="grey lighten-1"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="editScore(item)">
                          <v-list-item-icon class="mr-2">
                            <v-icon small> mdi-pencil </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              class="
                                font-weight-light
                                subtitle-2
                                text-capitalize
                              "
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.edit'
                                )
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="openConfirmDeleteTicket(item)">
                          <v-list-item-icon class="mr-2">
                            <v-icon small color="error"> mdi-delete </v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title
                              class="
                                font-weight-light
                                subtitle-2
                                error--text
                                text-capitalize
                              "
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.courseList.delete'
                                )
                              }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteTicket" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.warning1'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.warning2'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            dark
            outlined
            @click="closeDialogDeleteTicket"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2"
            color="error"
            dark
            @click="deleteTicket()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteTicketSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.successfullySave'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.successMsg1'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogDeleteTicketSuccess = false"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.done'
              )
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEditScoreExam"
      scrollable
      persistent
      max-width="1000px"
    >
      <v-card>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-spacer></v-spacer>
          <v-toolbar-title
            class="font-weight-light text-center ml-5 text-capitalize"
            >{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.editScore'
              )
            }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closedialogEditScoreExam">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-for="qList in arrQuestion" :key="qList.id">
            <v-card outlined elevation="0" class="mt-5">
              <v-toolbar
                outlined
                elevation="0"
                class="py-4"
                color="grey lighten-4"
                height="auto"
                min-height="80"
              >
                <v-col cols="9" class="pl-0">
                  <v-toolbar-title class="custom-question">
                    <p class="mb-0">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.question'
                        )
                      }}
                      {{ ' ' + (qList.priority + 1) }}.<br/>
                      <span v-if="qList.articleQuestion" @click="openArticle(qList.articleQuestion)">
                        <span class="article-title">
                          {{$vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.fromArticle')}}
                        </span>
                        <v-btn
                          color="primary"
                          depressed
                          small
                        >
                          <v-icon left>
                            mdi-file-document-outline
                          </v-icon>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.insertExam.article'
                            )
                          }}
                        </v-btn>
                      </span>
                      <span
                        v-html="qList.question"
                        class="font-weight-bold"
                      ></span>
                    </p>
                  </v-toolbar-title>
                  <span class="ssubtitle-2 grey--text">
                    ({{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.typeExam'
                      )
                    }}: {{ question_type[qList.questionType] }})
                  </span>
                </v-col>

                <v-col cols="3">
                  <v-row>
                    <v-col class="pl-0 pt-5"
                      >{{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.score'
                        )
                      }}
                      :</v-col
                    >
                    <v-col class="pa-0">
                      <v-text-field
                        class="mt-3"
                        v-model="qList.studentScore"
                        :disabled="qList.boolean == false"
                        single-line
                        outlined
                        type="number"
                        min="0"
                        background-color="white"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-right pa-0" cols="12">
                      <v-btn
                        v-if="qList.boolean == false"
                        :disabled="
                          bool == true ||
                          (!qList.studentAnswer &&
                            !qList.studentAnswerText &&
                            !qList.studentAnswerMatch &&
                            !qList.studentAnswerMemoryGame &&
                            !qList.studentAnswerPuzzleGrid)
                        "
                        elevation="0"
                        class="mb-0 body-2 text-primary text-capitalize"
                        color="white"
                        @click="editScoreExam(qList)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseList.edit'
                            )
                          }}
                        </p>
                      </v-btn>
                      <v-btn
                        v-if="qList.boolean == true"
                        elevation="0"
                        class="mb-0 body-2 text-blue-grey text-capitalize mr-2"
                        color="white"
                        @click="cancelEditScore(qList)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseList.cancel'
                            )
                          }}
                        </p>
                      </v-btn>
                      <v-btn
                        v-if="qList.boolean == true"
                        elevation="0"
                        class="mb-0 body-2 text-primary text-capitalize ml-2"
                        color="white"
                        @click="saveEditScore(qList)"
                      >
                        <p class="mb-0">
                          {{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.courseList.save'
                            )
                          }}
                        </p>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-toolbar>
              <v-card-text>
                <p
                  v-if="
                    qList.questionType == 'memorygame' &&
                    qList.studentAnswerMemoryGame != null
                  "
                  class="mb-0 success--text font-weight-black display-5"
                >
                  ได้ตอบคำถามไปแล้ว
                </p>
                <p
                  v-if="
                    !qList.studentAnswer &&
                    !qList.studentAnswerText &&
                    !qList.studentAnswerMatch &&
                    !qList.studentAnswerMemoryGame &&
                    !qList.studentAnswerPuzzleGrid
                  "
                  class="mb-0 error--text font-weight-black display-5"
                >
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.accessStep.manageLearners.reportExam.noAnswer'
                    )
                  }}
                </p>

                <v-list
                  v-if="
                    qList.questionType == 'single' &&
                    qList.studentAnswer != null
                  "
                >
                  <v-list-item
                    v-show="
                      qList.choices[0].text && qList.choices[0].text != ''
                    "
                    v-for="(rowChoiceText, index) in qList.choices"
                    :key="rowChoiceText._id + '_quiz_tab'"
                  >
                    <v-list-item-icon class="custom-icon">
                      <!-- <v-icon
                              v-show="
                                qList.studentAnswer[0] == rowChoiceText._id
                              "
                              :color="
                                getstudentCorrectAnser(
                                  qList.studentAnswer[0],
                                  qList.correctAnswer[0]._id
                                ) == rowChoiceText._id
                                  ? 'success'
                                  : 'error'
                              "
                            >
                              {{
                                getstudentCorrectAnser(
                                  qList.studentAnswer[0],
                                  qList.correctAnswer[0]._id
                                ) == rowChoiceText._id
                                  ? 'mdi-check'
                                  : 'mdi-close'
                              }}
                            </v-icon> -->
                    </v-list-item-icon>

                    <v-list-item-content>
                      <div class="d-flex">
                        <div
                          v-if="qList.studentAnswer == null"
                          class="custom-number-panel"
                        >
                          <div class="number-border">
                            <div class="number">
                              {{ index + 1 }}
                            </div>
                          </div>
                        </div>
                        <div class="custom-number-panel">
                          <div
                            class="number-border"
                            :class="
                              qList.studentAnswer[0] == rowChoiceText._id ||
                              qList.studentAnswer == null
                                ? 'have-number-border'
                                : ''
                            "
                          >
                            <div class="number">{{ index + 1 }}</div>
                          </div>
                        </div>

                        <div class="pa-5 mr-5 have-border ml-10 full-width">
                          <p class="mb-0" v-html="rowChoiceText.text"></p>
                        </div>
                      </div>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        :color="
                          qList.correctAnswer[0]._id == rowChoiceText._id
                            ? 'success'
                            : 'error'
                        "
                      >
                        {{
                          qList.correctAnswer[0]._id == rowChoiceText._id
                            ? 'mdi-check'
                            : 'mdi-close'
                        }}
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <div
                  v-if="
                    qList.questionType == 'multiple' &&
                    qList.studentAnswer != null
                  "
                >
                  <v-list>
                    <v-list-item
                      v-show="
                        qList.choices[0].text && qList.choices[0].text != ''
                      "
                      v-for="(rowChoiceText, index_choice) in qList.choices"
                      :key="rowChoiceText._id + '_quiz_tab'"
                    >
                      <!-- <v-list-item-icon class="custom-icon"> -->
                      <!-- <div
                                v-for="(
                                  studentAnswer, index
                                ) in qList.studentAnswer"
                                :key="index"
                              > -->

                      <!-- <v-icon
                                  v-if="studentAnswer != rowChoiceText._id"
                                  :color="
                                    chekCorrectAnswer(
                                      rowChoiceText._id,
                                      qList.correctAnswer
                                    ) && studentAnswer != rowChoiceText._id
                                      ? 'success'
                                      : ''
                                  "
                                >
                                  {{
                                    chekCorrectAnswer(
                                      rowChoiceText._id,
                                      qList.correctAnswer
                                    ) && studentAnswer != rowChoiceText._id
                                      ? 'mdi-check'
                                      : ''
                                  }}
                                </v-icon> -->
                      <!-- </div> -->
                      <!-- </v-list-item-icon> -->

                      <v-list-item-content>
                        <div class="d-flex">
                          <div
                            v-if="qList.studentAnswer == null"
                            class="custom-number-panel"
                          >
                            <div class="number-border">
                              <div class="number">
                                {{ index_choice + 1 }}
                              </div>
                            </div>
                          </div>

                          <div
                            class="custom-number-panel"
                            v-for="(
                              studentAnswer, index
                            ) in qList.studentAnswer"
                            :key="index"
                          >
                            <div
                              class="number-border"
                              :class="
                                studentAnswer == rowChoiceText._id
                                  ? 'have-number-border'
                                  : ''
                              "
                            >
                              <div class="number">
                                {{ index_choice + 1 }}
                              </div>
                            </div>
                          </div>

                          <div class="pa-5 mr-5 have-border ml-10 full-width">
                            <p class="mb-0" v-html="rowChoiceText.text"></p>
                          </div>
                        </div>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon
                          :color="
                            chekCorrectAnswer(
                              rowChoiceText._id,

                              qList
                            ) == true
                              ? 'success'
                              : 'error'
                          "
                        >
                          {{
                            chekCorrectAnswer(
                              rowChoiceText._id,

                              qList
                            ) == true
                              ? 'mdi-check'
                              : 'mdi-close'
                          }}
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </div>

                <div
                  v-if="
                    qList.questionType == 'fillgaptext' &&
                    qList.studentAnswerText != null
                  "
                >
                  <div
                    class="mb-5"
                    v-for="(answerText, index) in qList.studentAnswerText"
                    :key="index"
                  >
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.answer'
                        )
                      }}
                      <span> &nbsp; {{ index + 1 }}</span>
                    </p>
                    <div class="have-border mt-3 pa-2">
                      <p class="mb-0" v-html="answerText"></p>
                    </div>
                  </div>
                  <div class="mt-6">
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.examAnswer'
                        )
                      }}
                    </p>
                    <div class="have-border mt-3 pa-2">
                      <div
                        v-for="(correctText, index) in qList.correctText"
                        :key="index"
                      >
                        <p v-html="correctText"></p>
                        <v-divider
                          class="my-3"
                          v-show="
                            qList.correctText.length > 1 &&
                            index !== qList.correctText.length - 1
                          "
                        ></v-divider>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-show="
                    qList.questionType == 'matchsome' &&
                    qList.studentAnswerMatch != null
                  "
                >
                  <div class="py-5 full-width">
                    <div
                      v-for="(questionMatch, index) in qList.questionMatch"
                      :key="index"
                    >
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <div class="mb-1">
                            <p class="font-weight-bold">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.accessStep.manageLearners.reportExam.topic'
                                )
                              }}
                              &nbsp; {{ index + 1 }}
                            </p>
                            <p class="mb-0" v-html="questionMatch"></p>
                          </div>

                          <p class="font-weight-bold">
                            {{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.matchihng'
                              )
                            }}
                          </p>

                          <div
                            v-for="coices in qList.choices"
                            :key="coices._id"
                          >
                            <p v-html="coices.text"></p>
                          </div>
                        </div>

                        <!-- <div>
                          <v-btn
                            class="ma-2"
                            @click="
                              showAnswer(
                                qList.correctMatch[index],
                                qList.choices
                              )
                            "
                            outlined
                            color="success"
                            >{{
                              $vuetify.lang.t(
                                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.viewAnswer'
                              )
                            }}</v-btn
                          >
                        </div> -->
                      </div>
                      <v-divider
                        class="my-5"
                        v-show="index !== qList.questionMatch.length - 1"
                      ></v-divider>
                    </div>
                  </div>
                </div>

                <div
                  v-show="
                    (qList.questionType == 'wordsearch' ||
                      qList.questionType == 'crossword') &&
                    qList.studentAnswerPuzzleGrid != null
                  "
                >
                  <div
                    class="mb-2"
                    v-for="(answerText, index) in qList.studentAnswerPuzzleGrid"
                    :key="index"
                  >
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.answer'
                        )
                      }}
                      <span> &nbsp; {{ index + 1 }}</span>
                    </p>
                    <div class="have-border mt-2 pa-2">
                      <p class="mb-0" v-html="answerText.text"></p>
                    </div>
                  </div>
                  <div class="mt-6">
                    <p class="font-weight-bold">
                      {{
                        $vuetify.lang.t(
                          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.examAnswer'
                        )
                      }}
                    </p>
                    <div class="have-border mt-3 pa-2">
                      <div
                        v-for="(correctText, index) in qList.correctPuzzleGrid"
                        :key="index"
                      >
                        <p v-html="correctText.text"></p>
                        <v-divider
                          class="my-3"
                          v-show="
                            qList.correctPuzzleGrid.length > 1 &&
                            index !== qList.correctPuzzleGrid.length - 1
                          "
                        ></v-divider>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="text-center">
            <v-pagination
              v-model="page_editScore"
              :length="pageCount_editScore"
              @input="changePageEditScore()"
              color="rgb(66, 154, 216)"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <face-detection-dialog
      :isOpen.sync="dialogFaceDetection"
      :isClose="CloseFaceDetectionDialog"
      :ticketId.sync="ticketId"
    ></face-detection-dialog>

    <v-dialog v-model="confirmDeleteDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            "$vuetify.courseManagement.accessStep.manageLearners.reportExam.alertDeleteTicket"
          )
        }}</v-card-title>
        <v-card-text>
          <div>
            <v-alert
              type="warning"
            >
              {{$vuetify.lang.t(
                    "$vuetify.courseManagement.accessStep.manageLearners.reportExam.alertDeleteTicketCantBringData"
                  )}}
            </v-alert>
      </div>
      <div>
            <div class="exam-name-alert">{{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.courseReport.exam'
                    )
                  }}: {{examName}}
            </div>
            <br/>
      </div>
        <div>
        {{
          $vuetify.lang.t(
          '$vuetify.courseManagement.accessStep.manageLearners.reportExam.passwordContinuePlH'
          )
        }}
        </div>
          <p>
            {{
              $vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.password')
            }}
            <span class="red--text">*</span>
          </p>
          <v-text-field
            v-model="confirmPassword"
            outlined
            type="password"
            class="font-weight-light"
            clearable
            :placeholder="
              $vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.passwordPlH')
            "
          ></v-text-field>
          <div v-if="incorrectPassword">
            <v-alert
              outlined
              type="error"
              border="left"
            >
              Incorrect Password.
            </v-alert>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            dark
            outlined
            @click="closeConfirmDeleteDialog"
            >{{
              $vuetify.lang.t("$vuetify.courseManagement.lectureStep.cancel")
            }}</v-btn
          >
          <v-btn
            :disabled="!valid"
            class="px-10 ma-2"
            color="error darken-1"
            :loading="loadingDeleteAll"
            @click="deleteAllTicket"
            >{{
              $vuetify.lang.t("$vuetify.courseManagement.lectureStep.confirm")
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    
      <v-dialog
        v-model="articleDialogStatus"
        scrollable
        persistent
        max-width="800px"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-spacer></v-spacer>
            <v-toolbar-title
              class="font-weight-light text-center ml-5 text-capitalize"
              >{{$vuetify.lang.t('$vuetify.courseManagement.accessStep.manageLearners.reportExam.fromArticle')}}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeArticleDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>

          <div
            class="pt-5 article-content"
            v-html="article"
            ref="articleContainer"
            id="articleContainer"
          ></div>
        </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="selectExportDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.selectExportPattern'
          )
        }}</v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="selectExport"
            
          >
            <v-radio
              :label="$vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.all'
              )"
              value="all"
            ></v-radio>
            <v-radio
              :label="$vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.best'
              )"
              value="best"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            dark
            outlined
            @click="closeSelectExportDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2"
            color="primary"
            dark
            :loading="onExportExamLoading"
            @click="onExportWithUserGroup()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectAllExportDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.selectExportPattern'
          )
        }}</v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="selectAllExport"
            
          >
            <v-radio
              :label="$vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.all'
              )"
              value="all"
            ></v-radio>
            <v-radio
              :label="$vuetify.lang.t(
                '$vuetify.courseManagement.accessStep.manageLearners.reportExam.best'
              )"
              value="best"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            dark
            outlined
            @click="closeSelectAllExportDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2"
            color="primary"
            dark
            :loading="onExportAllExamLoading"
            @click="onExportAllExam()"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
import { getCourseById } from '@/service/course/course';
import faceDetectionDialog from '@/views/course/accessment/dialog/faceDetection/faceDetection.vue';
import {
  getExamReport,
  getExamCourse,
  getExamReportDetail,
  getExportExamReport,
} from '@/service/course/report';
import {
  getReportExamScore,
  getListQuestionExam,
  editScore,
  deleteTicketExam,
  deleteTicketAll
} from '@/service/course/course';
import { getUserGroup } from '@/service/account/manageUser';
export default {
  components: {
    faceDetectionDialog,
  },

  data() {
    return {
      loading: false,
      exam_item: [],
      dialogReportTicket: false,
      itemUserTicket: [],
      userTicket: [],
      users: [],
      idExam: '',
      itemExam: [],
      page_editScore: 1,
      dialogEditScoreExam: false,
      dialogDeleteTicket: false,
      arrQuestion: [],
      dialogDeleteTicketSuccess: false,
      pageCount_editScore: 1,
      ticketId: null,
      question_type: {
        single: 'ตัวเลือกเดียว',
        fillgaptext: 'เติมคำ',
        matchsome: 'จับคู่',
        multiple: 'หลายตัวเลือก',
        memorygame: 'เกมความจำ',
        crossword: 'เกมไขว้คำ',
        wordsearch: 'เกมหาคำ',
      },
      listTicketloading: false,
      passwordRules: [(v) => !!v || 'Password is required'],
      // headers: [
      //   {
      //     text: 'ชื่อ-สกุล',
      //     value: 'fullName',
      //     align: 'start',
      //     sortable: false,
      //   },
      //   // {
      //   //   text: 'ชื่อผู้ใช้งาน',
      //   //   align: 'start',
      //   //   sortable: false,
      //   //   value: 'username',
      //   // },

      //   {
      //     text: 'อีเมล',
      //     value: 'email',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'ครั้งที่',
      //     value: 'no',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'วันที่สอบ',
      //     value: 'examDate',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'เวลาเริ่ม',
      //     value: 'start',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'เวลาสิ้นสุด',
      //     value: 'end',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'เวลาที่ใช้',
      //     value: 'timer',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'คะแนน',
      //     value: 'score',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'ตอบถูก',
      //     value: 'correct',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'ตอบผิด',
      //     value: 'wrong',
      //     align: 'start',
      //     sortable: false,
      //   },

      //   {
      //     text: 'ไม่ได้ตอบ',
      //     value: 'noAnswer',
      //     align: 'start',
      //     sortable: false,
      //     width: '150px',
      //   },

      //   {
      //     text: 'ตรวจจับใบหน้า',
      //     value: 'faceDetection',
      //     align: 'start',
      //     sortable: false,
      //     width: '150px',
      //   },
      // ],

      params: {},
      pageCount: 1,
      examSelect: '',
      fullScore: 0,
      totalQuestion: 0,
      numberOfTakingExam: 0,
      totalTakingExam: 0,
      faceDetectionPass: 0,
      faceDetectionFail: 0,
      dialogFaceDetection: false,

      //course info
      course_info: [],
      examReportDetail: [],

      //filter usergroup
      arrayGroup: [],
      userGroupSearch: [],
      selectAll: false,

      countTerm: [],
      checkFaceDetection: null,
      status_toggle: 0,
      examName: "",
      confirmDeleteDialog: false,
      confirmPassword: '',
      incorrectPassword: false,
      loadingDeleteAll: false,
      articleDialogStatus: false,
      article: "",
      onExportAllExamLoading: false,
      selectAllExportDialog: false,
      selectExportDialog: false,
      selectAllExport: 'all', //or best
      selectExport: 'all', //or best
      onExportExamLoading: false
    };
  },
  computed: {
    likesAllGroup() {
      return this.userGroupSearch.length === this.arrayGroup.length;
    },
    likesSomeGroup() {
      return this.userGroupSearch.length > 0 && !this.likesAllGroup;
    },
    icon() {
      if (this.likesAllGroup) return 'mdi-checkbox-marked';
      if (this.likesSomeGroup) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },

    likesAllCountTerm() {
      return (
        this.countTerm.length === this.examReportDetail[0].countterm.length
      );
    },
    likesSomeCountTerm() {
      return this.countTerm.length > 0 && !this.likesAllCountTerm;
    },
    iconCountTerm() {
      if (this.likesAllCountTerm) return 'mdi-checkbox-marked';
      if (this.likesSomeCountTerm) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    headers() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.prefix'
          ),
          align: 'start',
          sortable: false,
          value: 'prefix',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.fullName'
          ),
          align: 'start',
          sortable: false,
          value: 'fullName',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.email'
          ),
          align: 'start',
          sortable: false,
          value: 'email',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.note'
          ),
          align: 'start',
          sortable: false,
          value: 'note',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.numberExam'
          ),
          align: 'center',
          sortable: false,
          value: 'numberExam',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.statusFace'
          ),
          align: 'center',
          sortable: false,
          value: 'statusFace',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.courseReport.headers.action'
          ),
          align: 'center',
          sortable: false,
          value: 'action',
        },
      ];
    },
    headerStudentExam() {
      return [
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.no'
          ),

          align: 'center',
          sortable: false,
          value: 'num',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.examDate'
          ),
          align: 'center',
          sortable: false,
          value: 'examDate',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.start'
          ),
          value: 'start',
          align: 'center',
          sortable: false,
        },

        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.end'
          ),
          value: 'end',
          align: 'center',
          sortable: false,
        },

        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.timer'
          ),
          value: 'timer',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.score'
          ),
          align: 'center',
          sortable: false,
          value: 'score',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.correct'
          ),
          align: 'center',
          sortable: false,
          value: 'correct',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.wrong'
          ),
          align: 'center',
          sortable: false,
          value: 'wrong',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.noAnswer'
          ),
          align: 'center',
          sortable: false,
          value: 'noAnswer',
        },
        {
          text: this.$vuetify.lang.t(
            '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.faceDetection'
          ),
          align: 'center',
          sortable: false,
          value: 'faceDetect',
        },
        {
          align: 'center',
          sortable: false,
          value: 'action',
        },
      ];
    },
    valid(){
      return this.confirmPassword.length >= 8
    }
  },
  methods: {
    openConfirmDeleteDialog (){
      console.log("open")
      this.confirmPassword = ""
      this.confirmDeleteDialog = true
    },
    closeConfirmDeleteDialog (){
      this.confirmPassword = ""
      this.confirmDeleteDialog = false
    },
    openSelectExportDialog (){
      this.selectExportDialog = true
      this.selectExport = 'all'
    },
    closeSelectExportDialog (){
      this.selectExportDialog = false
      this.selectExport = 'all'
    },
    openSelectAllExportDialog (){
      this.selectAllExportDialog = true
      this.selectAllExport = 'all'
    },
    closeSelectAllExportDialog (){
      this.selectAllExportDialog = false
      this.selectAllExport = 'all'
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllGroup) {
          this.userGroupSearch = [];
        } else {
          this.userGroupSearch = this.arrayGroup.slice();
          this.selectAll = true;
          this.applyFilterReportExam();
        }
      });
    },
    toggleCount() {
      this.$nextTick(() => {
        if (this.likesAllCountTerm) {
          this.countTerm = [];
        } else {
          this.countTerm = this.examReportDetail[0].countterm.slice();

          this.applyFilterReportExam();
        }
      });
    },
    async onExport() {
      this.onExportExamLoading = true
      let result = await getExportExamReport({
        ...this.params,
        limit: 5000,
        page: 1,
      });

      let users = [];
      await result.data.forEach(async (user) => {
        if (user.dataTicket.length > 0) {
          if(this.selectExport == "best"){
            let bestIndex = null
            let bestScore = -9999
            let bestTimer = Infinity
            for (let i = 0; i < user.dataTicket.length; i++) {
              if(user.dataTicket[i].score > bestScore){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              } else if(user.dataTicket[i].score == bestScore && user.dataTicket[i].timer < bestTimer){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              }
            }
            let info = {
                prefix: user.student.prefix,
                fullName: user.student.firstName + ' ' + user.student.lastName,
                email: user.student.email,
                note: user.student.school,
                examDate: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('DD/MM/YYYY')
                  : '-',
                start: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('HH:mm')
                  : '-',
                end:
                  user.dataTicket[bestIndex].created_at || user.dataTicket[bestIndex].timer
                    ? moment(
                        user.dataTicket[bestIndex].created_at + user.dataTicket[bestIndex].timer
                      ).format('HH:mm')
                    : '-',

                timer:
                  user.dataTicket[bestIndex].timer > 0
                    ? this.getTimer(user.dataTicket[bestIndex].timer)
                    : '-',
                countQuestion: user.dataTicket[bestIndex].countQuestion,
                fullScore: user.dataTicket[bestIndex].maxScore,
                score: user.dataTicket[bestIndex].score,
                correct: user.dataTicket[bestIndex].correct,
                wrong: user.dataTicket[bestIndex].wrong,
                noAnswer: user.dataTicket[bestIndex].noAnswer,

                statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
              };
              users.push(info);
          } else{
          for (let i = 0; i < user.dataTicket.length; i++) {
            let info = {
              // username: user.student.username,
              prefix: user.student.prefix,
              fullName: user.student.firstName + ' ' + user.student.lastName,
              email: user.student.email,
              note: user.student.school,
              examDate: user.dataTicket[i].created_at
                ? moment(user.dataTicket[i].created_at).format('DD/MM/YYYY')
                : '-',
              start: user.dataTicket[i].created_at
                ? moment(user.dataTicket[i].created_at).format('HH:mm')
                : '-',
              end:
                user.dataTicket[i].created_at || user.dataTicket[i].timer
                  ? moment(
                      user.dataTicket[i].created_at + user.dataTicket[i].timer
                    ).format('HH:mm')
                  : '-',

              timer:
                user.dataTicket[i].timer > 0
                  ? this.getTimer(user.dataTicket[i].timer)
                  : '-',
              countQuestion: user.dataTicket[i].countQuestion,
              fullScore: user.dataTicket[i].maxScore,
              score: user.dataTicket[i].score,
              correct: user.dataTicket[i].correct,
              wrong: user.dataTicket[i].wrong,
              noAnswer: user.dataTicket[i].noAnswer,

              statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
            };
            users.push(info);
          }
          }
        } else {
          let info = {
            // username: user.student.username,
            prefix: user.student.prefix,
            fullName: user.student.firstName + ' ' + user.student.lastName,
            email: user.student.email,
            note: user.student.school,
            examDate: '-',
            start: '-',
            end: '-',
            timer: '-',
            countQuestion: '-',
            fullScore: '-',
            score: '-',
            correct: '-',
            wrong: '-',
            noAnswer: '-',
            statusFace: '-',
          };
          users.push(info);
        }
      });
      console.log('onExport -> users', users);

      const dataWS = XLSX.utils.json_to_sheet(users);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      // XLSX.writeFile(wb, this.course_info + `_` + `ExamReport` + `.xlsx`);
      let exelName = this.examName
      if(this.selectExport == "best"){
        exelName = `${exelName}_best`
      }
      XLSX.writeFile(wb, exelName + `.xlsx`);
      this.onExportExamLoading = false
      this.closeSelectExportDialog()
    },
    async initialize() {
      this.params = {
        page: 1,
        limit: 25,
        idexam: '',
        groupnull: false,
      };
      let course = {
        id: this.$route.query.id,
      };
      await this.getUserGroupList();
      await this.getCourseDetail(course);

      // await this.getExam(course)
      // await this.getOndemandReport();
    },
    async onExportAllExam() {
      this.onExportAllExamLoading = true
      const wb = XLSX.utils.book_new();
      console.log(this.exam_item)
      let totalSheet = []
      for(let [idx,exam] of this.exam_item.entries()){
      let result = await getExportExamReport({
        limit: 5000,
        page: 1,
        idexam: exam._id,
      });
      totalSheet.push({title: exam.title, user:[], totalScore: exam.totalScore})

      let users = [];
      await result.data.forEach(async (user) => {
        let userGroup = user.student.user_groups.map(userGroup=>(userGroup.title))
        let userGroupTitle = userGroup.join(',')
        if (user.dataTicket.length > 0) {
          if(this.selectAllExport == "best"){
            let bestIndex = null
            let bestScore = -9999
            let bestTimer = Infinity
            for (let i = 0; i < user.dataTicket.length; i++) {
              if(user.dataTicket[i].score > bestScore){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              } else if(user.dataTicket[i].score == bestScore && user.dataTicket[i].timer < bestTimer){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              }
            }
            let info = {
                prefix: user.student.prefix,
                fullName: user.student.firstName + ' ' + user.student.lastName,
                email: user.student.email,
                note: user.student.school,
                examDate: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('DD/MM/YYYY')
                  : '-',
                start: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('HH:mm')
                  : '-',
                end:
                  user.dataTicket[bestIndex].created_at || user.dataTicket[bestIndex].timer
                    ? moment(
                        user.dataTicket[bestIndex].created_at + user.dataTicket[bestIndex].timer
                      ).format('HH:mm')
                    : '-',

                timer:
                  user.dataTicket[bestIndex].timer > 0
                    ? this.getTimer(user.dataTicket[bestIndex].timer)
                    : '-',
                countQuestion: user.dataTicket[bestIndex].countQuestion,
                fullScore: user.dataTicket[bestIndex].maxScore,
                score: user.dataTicket[bestIndex].score,
                correct: user.dataTicket[bestIndex].correct,
                wrong: user.dataTicket[bestIndex].wrong,
                noAnswer: user.dataTicket[bestIndex].noAnswer,

                statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
                userGroup: userGroupTitle
              };
              users.push(info);
              totalSheet[idx].user.push({
                prefix: info.prefix,
                fullName: info.fullName,
                fullScore: info.fullScore,
                score: info.score,
                email: info.email,
                userGroup: info.userGroup
              })
          } else{
              for (let i = 0; i < user.dataTicket.length; i++) {
                let info = {
                  // username: user.student.username,
                  prefix: user.student.prefix,
                  fullName: user.student.firstName + ' ' + user.student.lastName,
                  email: user.student.email,
                  note: user.student.school,
                  examDate: user.dataTicket[i].created_at
                    ? moment(user.dataTicket[i].created_at).format('DD/MM/YYYY')
                    : '-',
                  start: user.dataTicket[i].created_at
                    ? moment(user.dataTicket[i].created_at).format('HH:mm')
                    : '-',
                  end:
                    user.dataTicket[i].created_at || user.dataTicket[i].timer
                      ? moment(
                          user.dataTicket[i].created_at + user.dataTicket[i].timer
                        ).format('HH:mm')
                      : '-',

                  timer:
                    user.dataTicket[i].timer > 0
                      ? this.getTimer(user.dataTicket[i].timer)
                      : '-',
                  countQuestion: user.dataTicket[i].countQuestion,
                  fullScore: user.dataTicket[i].maxScore,
                  score: user.dataTicket[i].score,
                  correct: user.dataTicket[i].correct,
                  wrong: user.dataTicket[i].wrong,
                  noAnswer: user.dataTicket[i].noAnswer,

                  statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
                  userGroup: userGroupTitle
                };
                users.push(info);
              }
          }
        } else {
          let info = {
            // username: user.student.username,
            prefix: user.student.prefix,
            fullName: user.student.firstName + ' ' + user.student.lastName,
            email: user.student.email,
            note: user.student.school,
            examDate: '-',
            start: '-',
            end: '-',
            timer: '-',
            countQuestion: '-',
            fullScore: '-',
            score: '-',
            correct: '-',
            wrong: '-',
            noAnswer: '-',
            statusFace: '-',
            userGroup: userGroupTitle
          };
          users.push(info);
          totalSheet[idx].user.push({
            prefix: info.prefix,
            fullName: info.fullName,
            fullScore: info.fullScore,
            score: 0,
            email: info.email,
            userGroup: info.userGroup
          })
        }
      });
      console.log('onExport -> users', users);

      const dataWS = XLSX.utils.json_to_sheet(users);
      // const wb = XLSX.utils.book_new();
      let examTitle = exam.title

      if(examTitle.length>30){
        examTitle = examTitle.slice(0,12) + '...'+ examTitle.slice(-12)
      }
      examTitle = examTitle.replaceAll(/\\/g,"_")
      examTitle = examTitle.replaceAll("/","_")
      examTitle = examTitle.replaceAll("?","_")
      examTitle = examTitle.replaceAll("*","_")
      examTitle = examTitle.replaceAll("[","_")
      examTitle = examTitle.replaceAll("]","_")

      XLSX.utils.book_append_sheet(wb, dataWS, examTitle);
      // XLSX.writeFile(wb, this.course_info + `_` + `ExamReport` + `.xlsx`);
      }
      try{
        let equalStudent = true
        if(this.selectAllExport == "best" && totalSheet.length>0 && totalSheet[0].user.length>0){ //check number of student
          let totalStudent = null
          for(let [index,exam] of totalSheet.entries()){
            if(totalStudent == null){
              totalStudent = exam.user.length
            } else if(totalStudent !== exam.user.length){
              equalStudent = false
              break;
            }
            
          }
        }
        if(this.selectAllExport == "best" && totalSheet.length>0 && totalSheet[0].user.length>0 && equalStudent){
          let jsonSheet = []
          for(let [index,user] of totalSheet[0].user.entries()){ //generate user row.
            jsonSheet.push({prefix: user.prefix, fullName: user.fullName, email: user.email, total: 0, userGroup: user.userGroup})
          }

          let totalScore = { prefix: '-', fullName: 'total', email: '-', total: 0, userGroup: '-' } //generate total score row.
          for(let [idx,exam] of this.exam_item.entries()){
            let keyField = exam.title
            totalScore[keyField] = exam.totalScore
            totalScore["total"] += exam.totalScore
          }
          let headersTotal = ["prefix","fullName", "email"]
          for(let [idxExam,exam] of totalSheet.entries()){
            headersTotal.push(exam.title)
            for(let [idxUser,user] of exam.user.entries()){
              jsonSheet[idxUser][exam.title] = user.score
              jsonSheet[idxUser]["total"] += user.score
            }
          }
          headersTotal.push("total")
          headersTotal.push("userGroup")
          jsonSheet.splice(0, 0, totalScore)
          const dataWS = XLSX.utils.json_to_sheet(jsonSheet, {header:headersTotal});
          XLSX.utils.book_append_sheet(wb, dataWS, "Total")
        }
      } catch(error){
        console.log(error)
      }
      let exelName = this.course_info+'_exam'
      if(this.selectAllExport == "best"){
        exelName = `${exelName}_best`
      }
      XLSX.writeFile(wb, exelName + `.xlsx`);
      this.onExportAllExamLoading = false
      this.closeSelectAllExportDialog()
    },
    async getCourseDetail(param) {
      this.live_item = [];
      let detail = await getCourseById(param);
      this.course_info = detail.title;

      // this.params.idexam = detail.sections[0].lectures[0].exams[0]._id;
      // this.examSelect = detail.sections[0].lectures[0].exams[0]._id;

      this.params.idexam = null;
      this.examSelect = null;

      // this.exam_item = result
      let examList = [];
      for (let section of detail.sections) {
        for (let lecture of section.lectures) {
          if (lecture.type == 'EXAM') {
            if (!this.examSelect) {
              this.params.idexam = lecture.exams[0]._id;
              this.examSelect = lecture.exams[0]._id;
              this.checkFaceDetection = lecture.exams[0].faceDetection;
            }
            await examList.push({
              _id: lecture.exams[0]._id,
              title: lecture.exams[0].title,
              faceDetection: lecture.exams[0].faceDetection,
              totalScore: lecture.exams[0].totalScore,
            });
            // break
          }
        }
        // if(this.examSelect){
        //     break
        // }
      }

      this.exam_item = examList;
      console.log('getCourseDetail -> this.exam_item', this.exam_item);
      // this.paramExam = {
      //   idexam: this.exam_item[0]._id,
      // };
      let idexam = this.exam_item[0]._id;
      this.examName = this.exam_item[0].title
      this.idExam = idexam;

      console.log(this.exam_item);
      console.log(this.idExam);

      await this.getExamReportDetail();
      await this.getReport();
    },

    async changePage(page) {
      this.params.page = page;
      await this.getReport();
    },
    getTime(time) {
      //let time_info = "";
      let h = new Date(time).getHours();
      let m = new Date(time).getMinutes();

      if (h < 10) {
        h = '0' + h;
      }

      if (m < 10) {
        m = '0' + m;
      }

      //time_info =
      // parseInt(h) < 9 ? "0" + h : h + ":" + parseInt(m) < 9 ? "0" + m : m;
      return h + ':' + m + ' น.';
    },
    getTimer(timer) {
      var sec_num = parseInt(timer / 1000); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return hours + ':' + minutes + ':' + seconds;
    },
    // async getExam(params) {
    //   this.exam_item = [];
    //   let data = {
    //     course: params.id,
    //   };
    //   let result = await getExamCourse(data);
    //   console.log('result', result);
    //   this.exam_item = result;
    // },
    async filterReport() {
      this.idExam = this.examSelect;
      this.params.idexam = this.examSelect;
      this.exam_item.forEach((exam) => {
        if (this.examSelect == exam._id) {
          this.checkFaceDetection = exam.faceDetection;
          this.examName = exam.title
        }
      });
      await this.getExamReportDetail();
      await this.getReport();
    },
    async getExamReportDetail() {
      this.examReportDetail = [];
      console.log(this.idExam);
      let result = await getExamReportDetail({ idexam: this.idExam });

      this.examReportDetail.push(result);

      console.log(
        'getExamReportDetail -> this.examReportDetail',
        this.examReportDetail
      );
    },
    async getReport() {
      this.loading = true;
      this.users = [];
      let result = await getExamReport(this.params);

      console.log('getExamReport', result);

      // this.fullScore = result.data.dataTicket[0].maxScore;
      // this.totalQuestion = result.data.dataTicket[0].countQuestion;
      this.numberOfTakingExam = result.data.length;
      this.totalTakingExam = result.count;
      //   this.faceDetectionPass = result.data.dataTicket[0].maxScore;
      //   this.faceDetectionFail = result.data.dataTicket[0].maxScore;

      this.pageCount = result.maxPage;
      result.data.forEach((user) => {
        let info = {
          id: user.student._id,
          prefix: user.student.prefix,
          username: user.student.username,
          fullName: user.student.firstName + ' ' + user.student.lastName,
          email: user.student.email,
          note: user.student.school,
          statusFace: user.statusFace,
          countTicket: user.countTicket,
        };

        this.users.push(info);
      });
      this.loading = false;
    },
    async getListTicketExam() {
      this.userTicket = [];
      await this.setLoadingTicketList(true)
      let result = await getReportExamScore({
        idexam: this.idExam,
        idstudent: this.itemUserTicket.id,
      });
      // this.itemUserTicket.infoTicket.forEach((ticket) => {
      //   this.userTicket.push({
      //     id: ticket.id,
      //     start: ticket.start,
      //     end: ticket.end,
      //     time: ticket.time,
      //     score: ticket.score,
      //     correct: ticket.correct,
      //     wrong: ticket.wrong,
      //     noAnswer: ticket.noAnswer,
      //     statusFace: ticket.statusFace,
      //   });
      // });

      let numExam = result.data.length + 1;
      if (result.pendingTicket) {
        for (let ticket of result.pendingTicket) {
          this.userTicket.push({
            idTicket: ticket._id,
            examId: this.primaryExamId,
            studentId: this.studentId,
            num: numExam,
            examDate:
              new Date(ticket.created_at).toDateString() +
              ' ' +
              new Date(ticket.created_at).toLocaleTimeString(),
            start:
              new Date(ticket.created_at).toDateString() +
              ' ' +
              new Date(ticket.created_at).toLocaleTimeString(),
            end:
              new Date(ticket.created_at + ticket.timer).toDateString() +
              ' ' +
              new Date(ticket.created_at + ticket.timer).toLocaleTimeString(),
            timer: ticket.timer > 0 ? this.getTimer(ticket.timer) : 0,
            score: ticket.score,
            correct: ticket.correct,
            wrong: ticket.wrong,
            noAnswer: ticket.noAnswer,
            pending: true,
            statusFace: ticket.statusFace,
            photoFace: ticket.photoFace,
          });
        }
      }
      for(let reportExam of result.data) {
      // result.data.forEach((reportExam) => {
        numExam--;
        this.userTicket.push({
          idTicket: reportExam._id,
          examId: this.primaryExamId,
          studentId: this.studentId,
          num: numExam,
          examDate:
            new Date(reportExam.created_at).toDateString() +
            ' ' +
            new Date(reportExam.created_at).toLocaleTimeString(),
          start:
            new Date(reportExam.created_at).toDateString() +
            ' ' +
            new Date(reportExam.created_at).toLocaleTimeString(),
          end:
            new Date(reportExam.created_at + reportExam.timer).toDateString() +
            ' ' +
            new Date(
              reportExam.created_at + reportExam.timer
            ).toLocaleTimeString(),
          timer: reportExam.timer > 0 ? this.getTimer(reportExam.timer) : 0,
          score: reportExam.score,
          correct: reportExam.correct,
          wrong: reportExam.wrong,
          noAnswer: reportExam.noAnswer,
          pending: false,
          statusFace: reportExam.statusFace,
          photoFace: reportExam.photoFace,
        });
      // });
      }
      await this.setLoadingTicketList(false)
      console.log('openDialogReportTicket -> this.userTicket', this.userTicket);
    },
    async setLoadingTicketList(status){
      this.listTicketloading = status
    },
    async openDialogReportTicket(item) {
      this.dialogReportTicket = true;
      console.log('openDialogReportTicket -> item', item);
      this.itemUserTicket = item;
      await this.getListTicketExam();
    },
    async closeDialogUserTicket() {
      this.dialogReportTicket = false;
      this.userTicket = [];
      await this.getReport();
    },
    openArticle(articleQuestion){
      console.log(articleQuestion)
      this.articleDialogStatus = true
      this.article = articleQuestion.article
    },
    closeArticleDialog(){
      this.articleDialogStatus = false
      this.article = ""
    },
    // async openDialogFaceDetection(item) {
    //   console.log(item);
    //   this.ticketId = item.id;

    //   this.dialogFaceDetection = true;
    // },
    // async CloseFaceDetectionDialog() {
    //   this.dialogFaceDetection = false;
    //   this.closeDialogUserTicket();
    //   await this.getReport();
    // },
    async getReportStudentExamScore(examId) {
      this.studentReportExams = [];
      this.primaryExamId = examId;
      let result = await getReportExamScore({
        idexam: examId,
        idstudent: this.studentId,
      });

      this.fullScore = result.maxScore;
      this.numOfQuestions = result.countQuestion;
      let numExam = result.data.length + 1;
      console.log(result);
      if (result.pendingTicket) {
        for (let ticket of result.pendingTicket) {
          this.studentReportExams.push({
            idTicket: ticket._id,
            examId: this.primaryExamId,
            studentId: this.studentId,
            num: numExam,
            examDate:
              new Date(ticket.created_at).toDateString() +
              ' ' +
              new Date(ticket.created_at).toLocaleTimeString(),
            start:
              new Date(ticket.created_at).toDateString() +
              ' ' +
              new Date(ticket.created_at).toLocaleTimeString(),
            end:
              ticket.endtime > 0
                ? new Date(ticket.created_at + ticket.timer).toDateString() +
                  ' ' +
                  new Date(
                    ticket.created_at + ticket.timer
                  ).toLocaleTimeString()
                : 0,
            timer: ticket.timer > 0 ? this.getTimer(ticket.timer) : 0,
            score: ticket.score,
            correct: ticket.correct,
            wrong: ticket.wrong,
            noAnswer: ticket.noAnswer,
            pending: true,
            statusFace: ticket.statusFace,
            photoFace: ticket.photoFace,
          });
        }
      }
      result.data.forEach((reportExam) => {
        numExam--;
        this.studentReportExams.push({
          idTicket: reportExam._id,
          examId: this.primaryExamId,
          studentId: this.studentId,
          num: numExam,
          examDate:
            new Date(reportExam.created_at).toDateString() +
            ' ' +
            new Date(reportExam.created_at).toLocaleTimeString(),
          start:
            new Date(reportExam.created_at).toDateString() +
            ' ' +
            new Date(reportExam.created_at).toLocaleTimeString(),
          end:
            new Date(reportExam.created_at + reportExam.timer).toDateString() +
            ' ' +
            new Date(
              reportExam.created_at + reportExam.timer
            ).toLocaleTimeString(),
          timer: reportExam.timer > 0 ? this.getTimer(reportExam.timer) : 0,
          score: reportExam.score,
          correct: reportExam.correct,
          wrong: reportExam.wrong,
          noAnswer: reportExam.noAnswer,
          pending: false,
          statusFace: reportExam.statusFace,
          photoFace: reportExam.photoFace,
        });
      });
      console.log(this.studentReportExams);
    },
    async getQuestionListExam() {
      let data = {
        idexam: this.idExam,
        idstudent: this.itemUserTicket.id,
        term: this.itemExam.num - 1,

        page: this.page_editScore,
        limit: 10,
      };
      let result = await getListQuestionExam(data);
      this.arrQuestion = [];
      result.data.forEach((quiz) => {
        // if (quiz.question.typeQuestion != "article") {
        this.arrQuestion.push({
          articleQuestion: quiz.question.articleQuestion,
          priority: quiz.question.priority,
          id: quiz.question._id,
          question: quiz.question.question,
          questionType: quiz.question.typeQuestion,
          choices: quiz.question.choices,
          correctAnswer: quiz.question.correct,
          correctText: quiz.question.correctText,
          questionMatch: quiz.question.questionMatch,
          correctMatch: quiz.question.correctMatch,
          correctPuzzleGrid: quiz.question.correctPuzzleGrid,
          // imageQuestion: quiz.question.imageQuestion,
          QuestionScore: quiz.question.score,

          studentAnswerText: quiz.answerStudent
            ? quiz.answerStudent.answerText
            : null,
          studentAnswerMatch: quiz.answerStudent
            ? quiz.answerStudent.answerMatch
            : null,
          studentAnswerMemoryGame: quiz.answerStudent
            ? quiz.answerStudent.answerMemoryGame
            : null,
          studentAnswerPuzzleGrid: quiz.answerStudent
            ? quiz.answerStudent.answerPuzzleGrid
            : null,
          studentAnswer:
            quiz.answerStudent && quiz.answerStudent.answer !== null
              ? quiz.answerStudent.answer
              : null,
          studentIdState: quiz.answerStudent ? quiz.answerStudent._id : null,
          studentScore: quiz.answerStudent ? quiz.answerStudent.score : 0,
          divider: true,
          boolean: false,
        });
        // }
      });
      this.pageCount_editScore = result.maxPage;
    },
    //check student anser correct
    getstudentCorrectAnser(idStudentAnsser, idCorrectAnser) {
      let id_correct = '';
      idStudentAnsser == idCorrectAnser
        ? (id_correct = idStudentAnsser)
        : (id_correct = '');
      return id_correct;
    },
    getCorrectAnser(idAnswer, correctAnser) {
      if (correctAnser.length) {
        correctAnser.forEach((correct) => {
          if (correct._id == idAnswer) {
            return correct._id;
          }
        });
        // let correct = correctAnser.filter((key) => key._id == idAnswer);
        // return correct;
      } else {
        let correct = correctAnser.filter((key) => key == idAnswer);
        return correct;
      }
    },
    chekCorrectAnswer(idChioce, correctAnswer) {
      let check = false;
      for (let index = 0; index < correctAnswer.correctAnswer.length; index++) {
        const correct = correctAnswer.correctAnswer[index];
        if (correct._id == idChioce) {
          check = true;
          break;
        }
      }

      return check;
    },

    showAnswer(corrects, choices) {
      let correct_match = [];
      choices.filter(function (choice) {
        corrects.correct.forEach((correct) => {
          console.log(correct, choice._id)
          if (correct == choice._id) {
            correct_match.push(choice);
          }
        });
      });
      // this.correct_matchsome = answer[0];
      this.correct_matchsome = correct_match;
      // console.log("showAnswer -> this.correct_matchsome", this.correct_matchsome)
      this.correct_dialog = true;
    },
    editScore(item) {
      this.itemExam = item;
      this.getQuestionListExam();
      this.dialogEditScoreExam = true;
    },
    async openDialogFaceDetection(item) {
      console.log(item);
      this.ticketId = item.idTicket;

      this.dialogFaceDetection = true;
    },
    async CloseFaceDetectionDialog() {
      this.dialogFaceDetection = false;
      await this.getListTicketExam();
      // await this.getReportStudentExamScore(this.primaryExamId);
      // this.closeDialogUserTicket();
      // await this.getReport();
    },
    editScoreExam(item) {
      this.bool = true;
      item.boolean = true;
      this.tempScore = item.studentScore;
      this.editScoreItem = item;
    },
    cancelEditScore(item) {
      item.boolean = false;
      item.studentScore = this.tempScore;
      this.bool = false;
    },

    async saveEditScore(item) {
      item.boolean = false;
      this.bool = false;

      this.editScoreItem = item;
      if (
        this.editScoreItem.studentScore == '' ||
        this.editScoreItem.studentScore == null
      ) {
        this.editScoreItem.studentScore = 0;
      }
      let data = {
        idstate: this.editScoreItem.studentIdState,
        score: this.editScoreItem.studentScore,
      };
      // for (var i = 0; i < this.pageCount_editScore; i++) {
      // for (var q = 0; q < this.arrQuestion.length; q++) {
      //   let result = await editScore({
      //     idstate: this.arrQuestion[q].studentIdState,
      //     score: this.arrQuestion[q].studentScore,
      //   });
      // console.log("post api page of : ", i, " && rpm : ", q);
      // console.log(result);
      // }
      // }
      let result = await editScore(data);
      if (result) {
        this.getQuestionListExam();
      }
      this.dialogSuccess = true;
      // this.closedialogEditScoreExam();
    },

    async changePageEditScore() {
      this.arrTempScore = [];
      this.arrQuestion.forEach((arrq) => {
        this.arrTempScore.push({
          score: arrq.studentScore,
        });
      });
      await this.getQuestionListExam();
    },

    openConfirmDeleteTicket(item) {
      // console.log(item);
      this.idTicket = item.idTicket;
      this.pendingTicket = item.pending;
      this.dialogDeleteTicket = true;
    },
    async deleteAllTicket(){
      let data = {
        examId: this.idExam,
        confirmPassword: this.confirmPassword,
      };
      this.loadingDeleteAll = true
      let result = await deleteTicketAll(data);
      this.loadingDeleteAll = false
      console.log(result.code, result,result.statusCode == "INCORRECT_PASSWORD")
      if (result.code && result.statusCode && result.statusCode == "INCORRECT_PASSWORD") {
        this.confirmPassword = ""
        this.incorrectPassword = true
        
      } else if(result.code) {
        console.log("error")
      } else {
        this.incorrectPassword = false
        await this.closeConfirmDeleteDialog()
        await this.getReport()
      }
    },
    async deleteTicket() {
      let data = {
        idticket: this.idTicket,
        pending: this.pendingTicket,
      };
      let result = await deleteTicketExam(data);
      if (result) {
        this.dialogDeleteTicket = false;
        await this.getListTicketExam();
        // await this.getReportStudentExamScore(this.primaryExamId);
        // console.log("delete ticket exam success");
        this.dialogDeleteTicketSuccess = true;
      }
    },

    closeDialogDeleteTicket() {
      this.dialogDeleteTicket = false;
      this.idTicket = '';
    },
    async closedialogEditScoreExam() {
      this.dialogEditScoreExam = false;
      this.arrQuestion = [];
      this.bool = false;
      await this.getListTicketExam();
      // await this.getReportStudentExamScore(this.primaryExamId);
    },
    async getUserGroupList() {
      let paramsG = {
        search: null,
        sort: 'created_at',
        sortby: -1,
        usergroup: null,
        page: 1,
        limit: 100,
        active: 'null',
      };
      let result = await getUserGroup(paramsG);
      this.groupUsers = [];
      this.arrayGroup = [];

      this.arrayGroup.push({
        title: 'ไม่มีกลุ่ม',
        _id: '',
      });

      await result.forEach(async (group) => {
        group.child_User_Group.length === 0
          ? await this.arrayGroup.push({
              title: group.title,
              _id: group._id,
            })
          : null;
        group.child_User_Group.forEach(async (child) => {
          child.child_User_Group.length === 0
            ? await this.arrayGroup.push({
                title: group.title + ' -> ' + child.title,
                _id: child._id,
              })
            : null;
          child.child_User_Group.forEach(async (lastChild) => {
            await this.arrayGroup.push({
              title:
                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
              _id: lastChild._id,
            });
          });
        });
      });
      this.groupUsers = result;
      await this.arrayGroup.filter((group) => group.active === true);
    },
    async applyFilterReportExam() {
      let itemUserGroupsId = [];
      let itemCountTerm = [];
      let statusFace = ['success', 'fail'];
      console.log(
        'applyFilterReportExam -> this.status_toggle',
        this.status_toggle
      );
      switch (this.status_toggle) {
        case 0:
          this.params.statusface = '';
          break;
        case 1:
          this.params.statusface = 'success';
          break;
        case 2:
          this.params.statusface = 'fail';
          break;
      }

      if (this.userGroupSearch.length == 0) {
        this.params.groupnull = false;
      }

      if (this.likesAllGroup) {
        this.params.groupnull = false;
      } else {
        this.userGroupSearch.forEach((group) => {
          if (group == '') {
            this.params.groupnull = true;
          } else {
            itemUserGroupsId.push(group);
          }
        });
      }

      if (this.likesSomeCountTerm) {
        this.countTerm.forEach((term) => {
          itemCountTerm.push(term);
        });
      }

      this.params.countterm = itemCountTerm;
      this.params.usergroup = itemUserGroupsId;
      await this.filterReport();
      //await this.getCourseList();
    },
    goToCourseDetail(){
      this.$router.push({
          path: '/course/detail',
          query: {
            id: this.$route.query.id,
            step: 1,
          },
        });
    },
    async onExportWithUserGroup() {
      this.onExportExamLoading = true
      let result = await getExportExamReport({
        ...this.params,
        limit: 5000,
        page: 1,
      });

      let userGroupFilter = this.userGroupSearch.length > 0 ? this.userGroupSearch : this.arrayGroup.map(group=>(group._id))
      let userGroupSheet = {}
      for(let userGroup of userGroupFilter){
        if(userGroup!== ""){
          userGroupSheet[`${userGroup}`]=[]
        }
      }
      let foundNoUserGroup = userGroupFilter.findIndex(userGroup=>userGroup=="")
      if(foundNoUserGroup>-1){
        console.log("None")
        userGroupSheet['none'] = []
      }
      console.log(userGroupSheet)

      // let users = [];
      await result.data.forEach(async (user) => {
        let users = null
        let userGroup = user.student.user_groups.map(userGroup=>(userGroup.title))
        let userGroupId = user.student.user_groups.map(userGroup=>(userGroup._id))
        let userGroupTitle = userGroup.join(',')
        if (user.dataTicket.length > 0) {
          if(this.selectExport == "best"){
            let bestIndex = null
            let bestScore = -9999
            let bestTimer = Infinity
            for (let i = 0; i < user.dataTicket.length; i++) {
              if(user.dataTicket[i].score > bestScore){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              } else if(user.dataTicket[i].score == bestScore && user.dataTicket[i].timer < bestTimer){
                bestIndex = i
                bestScore = user.dataTicket[i].score
                bestTimer = user.dataTicket[i].timer
              }
            }
            let info = {
                prefix: user.student.prefix,
                fullName: user.student.firstName + ' ' + user.student.lastName,
                email: user.student.email,
                note: user.student.school,
                examDate: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('DD/MM/YYYY')
                  : '-',
                start: user.dataTicket[bestIndex].created_at
                  ? moment(user.dataTicket[bestIndex].created_at).format('HH:mm')
                  : '-',
                end:
                  user.dataTicket[bestIndex].created_at || user.dataTicket[bestIndex].timer
                    ? moment(
                        user.dataTicket[bestIndex].created_at + user.dataTicket[bestIndex].timer
                      ).format('HH:mm')
                    : '-',

                timer:
                  user.dataTicket[bestIndex].timer > 0
                    ? this.getTimer(user.dataTicket[bestIndex].timer)
                    : '-',
                countQuestion: user.dataTicket[bestIndex].countQuestion,
                fullScore: user.dataTicket[bestIndex].maxScore,
                score: user.dataTicket[bestIndex].score,
                correct: user.dataTicket[bestIndex].correct,
                wrong: user.dataTicket[bestIndex].wrong,
                noAnswer: user.dataTicket[bestIndex].noAnswer,
                statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
                userGroup: userGroupTitle
              };
              users = info;
          } else{
          for (let i = 0; i < user.dataTicket.length; i++) {
            let info = {
              // username: user.student.username,
              prefix: user.student.prefix,
              fullName: user.student.firstName + ' ' + user.student.lastName,
              email: user.student.email,
              note: user.student.school,
              examDate: user.dataTicket[i].created_at
                ? moment(user.dataTicket[i].created_at).format('DD/MM/YYYY')
                : '-',
              start: user.dataTicket[i].created_at
                ? moment(user.dataTicket[i].created_at).format('HH:mm')
                : '-',
              end:
                user.dataTicket[i].created_at || user.dataTicket[i].timer
                  ? moment(
                      user.dataTicket[i].created_at + user.dataTicket[i].timer
                    ).format('HH:mm')
                  : '-',

              timer:
                user.dataTicket[i].timer > 0
                  ? this.getTimer(user.dataTicket[i].timer)
                  : '-',
              countQuestion: user.dataTicket[i].countQuestion,
              fullScore: user.dataTicket[i].maxScore,
              score: user.dataTicket[i].score,
              correct: user.dataTicket[i].correct,
              wrong: user.dataTicket[i].wrong,
              noAnswer: user.dataTicket[i].noAnswer,

              statusFace: user.statusFace == 'notface' ? '-' : user.statusFace,
              userGroup: userGroupTitle
            };
            users = info;
          }
          }
        } else {
          let info = {
            // username: user.student.username,
            prefix: user.student.prefix,
            fullName: user.student.firstName + ' ' + user.student.lastName,
            email: user.student.email,
            note: user.student.school,
            examDate: '-',
            start: '-',
            end: '-',
            timer: '-',
            countQuestion: '-',
            fullScore: '-',
            score: '-',
            correct: '-',
            wrong: '-',
            noAnswer: '-',
            statusFace: '-',
            userGroup: userGroupTitle
          };
          users = info;
        }
        // insert To sheet by userGroup
        if(userGroupId.length == 0){
          userGroupSheet['none'].push(users)
        } else {
          for(let groupId of userGroupId){
            if(userGroupSheet[`${groupId}`]){
              userGroupSheet[`${groupId}`].push(users)
            }
          }
        }
      });
      const wb = XLSX.utils.book_new();
      for(let sheetName in userGroupSheet){
        const dataWS = XLSX.utils.json_to_sheet(userGroupSheet[sheetName])
        let userGroupName = ""
        if(sheetName == "none"){
          userGroupName = "ไม่มีกลุ่ม"
        } else {
          let nameFound = this.arrayGroup.find(name=>sheetName === name._id)
          if(nameFound){
            let getLastName = nameFound.title.split(' -> ')
            let lastName = getLastName[getLastName.length - 1]
            if(lastName.length>30){
              userGroupName = lastName.slice(0,12) + '...'+ lastName.slice(-12)
            } else {
              userGroupName = lastName
            }
          }
        }
        userGroupName = userGroupName.replaceAll(/\\/g,"_")
        userGroupName = userGroupName.replaceAll("/","_")
        userGroupName = userGroupName.replaceAll("?","_")
        userGroupName = userGroupName.replaceAll("*","_")
        userGroupName = userGroupName.replaceAll("[","_")
        userGroupName = userGroupName.replaceAll("]","_")
        XLSX.utils.book_append_sheet(wb, dataWS, userGroupName)
      }

      let exelName = this.examName
      if(this.selectExport == "best"){
        exelName = `${exelName}_best`
      }
      XLSX.writeFile(wb, exelName + `.xlsx`);
      this.onExportExamLoading = false
      this.closeSelectExportDialog()
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.incorrect-password{
  color: red
}
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

td {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

th {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.custom-fix-width {
  min-width: 450px;
  max-width: 450px;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>

<style>
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: none;
}
.search-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 40px;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  height: 42px;
}
.text-field-border {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  min-height: 40px;
  color: rgb(77, 77, 77);
}
.org-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.mb0 {
  margin-bottom: 0px;
}

/* .editor {
    height: 200px;
    margin-bottom: 70px;
  } */

.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  /* margin-top: 7%; */
  margin-top: 5px;
}

.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.img {
  float: left;
  margin-right: 1rem;
}

.verticalLine {
  border-left: 3px solid #f5f5f5;
}

.rowCard {
  height: 400px;
  margin-top: 20px;
}

.titleCard {
  font-weight: bold;
  margin-top: 10px;
  color: rgb(0, 0, 0);
}

.logo {
  width: 20%;
  margin: 0 auto;
}

.login-page {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paddingImg {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 60%;
  height: 60%;
}

.paddingCard {
  padding: 5px;
}

.center-div {
  margin: 0 auto;
}

/* .v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
      -webkit-transform: unset;
      transform: unset;
  } */
/* .item-card {
    width: 30%;
    min-height: 300px;
  } */
@media only screen and (max-width: 768px) {
  /* .item-card {
      width: 100%;
    } */
  .login-page {
    height: 100%;
    align-items: unset;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}

@media only screen and (min-width: 769px) and (max-width: 1024px) {
  /* .item-card {
      width: 60%;
      min-height: 560px;
    } */

  .login-page {
    height: 100%;
    align-items: center;
  }

  .v-application .pa-12 {
    padding: 10px !important;
  }
}
.correct {
  color: #4caf50;
  border: 1px solid #4caf50 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #4caf50;
    }
  }

  p {
    color: #4caf50;
  }
}

.incorrect {
  color: #f44336;
  border: 1px solid #f44336 !important;

  .check {
    position: absolute;
    left: 5px;
    top: 13px;

    i {
      color: #f44336;
    }
  }

  p {
    color: #f44336;
  }
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.selectCourse {
  height: auto;
}

.fixed-heght {
  height: 30px;
}

.rounded-card {
  border-radius: 8px;
}

/* .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px;
  } */
.v-input__append-inner {
  margin-top: 9px !important;
}

.md-fixed-max-width {
  max-width: 200px;
}

.add-course .full-width {
  width: 100%;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.apexcharts-toolbar {
  visibility: hidden;
  display: none;
}

.d-flex {
  display: flex;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    display: none;
  }

  .xs-full-max-width {
    max-width: 100%;
  }

  .md-fixed-width {
    width: 150px;
  }

  .xs-fixed-width {
    width: 100px;
  }

  .table-header {
    height: auto !important;
  }

  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column !important;
    padding: 0 !important;
  }

  .xs-full-width {
    width: 50%;
  }
}

.border-bottom {
  border-bottom: 1px solid #cfd8dc;
}

.border-bottom:last-child {
  border-bottom: none;
}

.full-width {
  width: 100%;
}

.filter-header {
  display: flex;
  justify-content: space-between;
}

.md-border {
  border: 1px solid #bdbdbd;
}

.text-caption {
  color: #9b9b9b;
  text-transform: uppercase;
}

.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}

.hidden-md {
  display: none;
}

.main {
  background-color: rgb(241, 243, 245);
}

.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.button-danger {
  color: #ff5252 !important;
  border: 1px solid rgb(195, 195, 195);
}

.text-field-border {
  border: 1px solid;
  /* border-radius: 8px; */
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.title-text {
  color: rgb(140, 140, 140);
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.have-border {
  border: thin solid #e4e4ee;
  border-radius: 4px;
}

.stat-num {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.stat-num-top {
  background-image: linear-gradient(rgba(#0779e4, 1), rgba(#0779e4, 0.7));
  color: white;
}

.stat-num-total {
  background-image: linear-gradient(rgba(#9f4355, 1), rgba(#9f4355, 0.7));
  color: white;
}

.stat-num-today {
  background-image: linear-gradient(rgba(#482f4d, 1), rgba(#482f4d, 0.7));
  color: white;
}

.stat-num-online {
  background-image: linear-gradient(rgba(#699ab2, 1), rgba(#699ab2, 0.7));
  color: white;
}

.stat-num-not-completed {
  background-image: linear-gradient(rgba(#ec0101, 1), rgba(#ec0101, 0.5));
  color: white;
}

.stat-num:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  /* background-color: rgba(#0779e4, 0.4); */
  transform: scale(1.05, 1.05);
}

.graph-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 5px;
  background-color: white;
  transition: transform 0.3s ease-in-out;
}

.graph-card:hover {
  /* box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.19); */
  transform: scale(1.02, 1.02);
}

.v-application p {
  margin: 0 !important;
}

.number-border {
  /* padding: 5px; */
  width: 30px;
  height: 30px;
  position: relative;
}

.have-number-border {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  background: #bdbdbd87;
}

.number {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

p img {
  width: 100% !important;
}

.custom-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  margin-top: 0;
}

.custom-number-panel {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
.v-data-table.custom-table td {
  height: 0;
  padding: 0;
}

.v-data-table.custom-table td .backgroud-info {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #2196f3;
}

.v-data-table.custom-table td .backgroud-success {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #4caf50;
}

.v-data-table.custom-table td .backgroud-error {
  height: 48px;
  padding: 13px 0;

  border-bottom: 3px solid #f44336;
}

.v-data-table.custom-table td .backgroud-warning {
  height: 48px;
  padding: 13px 0;
  border-bottom: 3px solid #ffc107;
}

.v-data-table.custom-table thead tr th:nth-child(9) {
  border-bottom: 3px solid #ffc107 !important;
}

.v-data-table.custom-table thead tr th:nth-child(8) {
  border-bottom: 3px solid #f44336 !important;
}

.v-data-table.custom-table thead tr th:nth-child(7) {
  border-bottom: 3px solid #4caf50 !important;
}

.v-data-table.custom-table thead tr th:nth-child(6) {
  /*background: #B3E5FC !important;*/
  border-bottom: 3px solid #2196f3 !important;
}

.custom-question p {
  margin-bottom: 5px !important;
}

p > img {
  width: 100% !important;
}

.bg-sheet {
  background: #fafafa !important;
}

.pending-btn {
  padding: 7px;
  color: #fb8c00;
}
.article-title{
  font-size: 18px;
  margin-right: 10px;
}
.exportAllExam{
  border-color: #429AD8 !important;
  background-color: white !important;
  color: #429AD8 !important;
}
</style>
<style lang="scss">
  .justify-content-right{
    justify-content: flex-end;
    height: 40px;
  }
  .exam-name-alert{
    font-size: 20px;
  }
</style>
